export default "__VITE_ASSET__YEVCiNQ7__"